<template>
  <!-- 增值服务 -->
  <el-container class="valueservice">
    <!-- <el-header :height="'70'">
      <home-header :opacity="opacity"></home-header>
    </el-header> -->
    <el-main>
      <div class="maintop">
        <div style="color:white">
          <div style="text-align:center;font-size:18px;margin-bottom:10px"><h2>增值服务</h2></div>
          <div>
            <span>《中山画刊》</span>
            <span>|</span>
            <span>内刊画册定制</span>
            <span>|</span>
            <span>特约拍摄</span>
            <span>|</span>
            <span>活动策划与执行</span>
            <span>|</span>
            <span>VI设计</span>
            <span>|</span>
            <span>数字资产管理</span>
          </div>
        </div>
      </div>
      <div class="mainbottom">
        <busine-sssector v-for="(item,index) in list" :obj="item" :key="index"></busine-sssector>
      </div>
    </el-main>
    <el-footer v-if="hidefooter" style="height:316px">
      <home-footer></home-footer>
    </el-footer>
  </el-container>
</template>
<script>
import homeFooter from "../components/homeFooter.vue"; //底部
import homeHeader from "../components/homeHeader.vue"; //头部
import homeHeaderAd from "../components/homeHeaderAd.vue"; //头部
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import busineSssector from "../components/busineSssector"; //业务板块
import {mapGetters,mapActions} from 'vuex'
export default {
  components: {
    homeHeader,
    homeHeaderAd,
    homeFooterAd,
    busineSssector,
    homeFooter
  },
  computed:{
    ...mapGetters(['hidefooter'])
  },
  data() {
    return {
      list: [
        {
          color: "#E93830",
          title: "中山文化外宣刊物-《中山画刊》",
          desc: `《中山画刊》创刊于2001年，每月免费派送约22000册，主要由中山日报报业集团发行公司的专业发行人员派发。重点向中山的高档消费场所，中港客运贵宾舱，各商协会，各镇区有关职能部门，市委、市政府各职能部门，企事业单位，合作伙伴等免费赠阅。2018年，根据中山市委宣传部加强外宣工作、讲好中山故事的指示，《中山画刊》正式改版升级为中山市文化外宣刊物。

《中山画刊》除了为合作伙伴提供原创采编、摄影等服务，还开辟有城事、瞬间、风物、景致、行走、味蕾、人物等栏目，欢迎广大摄影师、摄影爱好者、旅行达人，文艺文学创作者踊跃投稿。

          `
        },
        {
          color: "#B5B5B5",
          title: "内刊画册定制",
          desc: `在纸媒生存艰难的现实大环境下，通过与客户、读者多次座谈交流，我们得知，尽管新媒体传播形式更加多元化，但“纸”这种传统媒介仍有魅力，尤其是具备较强视觉欣赏功能的杂志和画册，有特殊的传播价值和空间。

中山报业中新传媒目前承接的刊物有：中山市政协的《和》、完美集团的《完美》、中山市国资委的《中山国资》、中山市卫生计生局的《中山卫生》、党史办的《中山党史》等。近年来承接的画册近百本，比如《中山改革进行时》、《中山慈善万人行30年》、《中山宗祠》、《云端看中山》、《中山历史影像》等。
`
        },
        {
          color: "#496976",
          title: "特约拍摄服务",
          desc: `中山报业中新传媒拥有中山地区众多的签约摄影师资源，通过专业的摄影、摄像、编辑团队，利用摄影新技术可以全程为您提供全面优质的影像记录。
          `
        },
        {
          color: "#E6B884",
          title: "活动策划与执行",
          desc: `凭借中山报业传媒的后盾支撑优势，以及对中山市情民意的深刻理解，中山报业中新传媒近年来为各政府部门、各行各业的商家、企事业单位等策划组织了150多项、300多场各类活动。活动涉及文体、才艺、摄影、亲子、公益、图片展览展示等。我们有信心、有能力承办您的各类活动，欢迎您咨询洽谈。`
        },
        {
          color: "#C9635E",
          title: "品牌视觉形象系统（VI）",
          desc: `VI设计是中山报业中新传媒的全新业务版块。基础部分，我们可以为您的商铺、企业量身定制完成logo设计的全部内容，包括设计稿、设计说明、标准制图、标准色、辅助色等。应用部分，您的商铺、企业所有需要用到的物料，小到名片，大到车体、户外形象展示等设计应用，我们都可以帮您搞定。`
        },
        {
          color: "#666666",
          title: "数字资产管理系统DAM",
          desc: `“中山影像”平台是引入国内领先的视觉中国集团基于云计算、大数据等平台技术的超大型影像库搜索及存储技术搭建而成的，基于此，我们也将推出专业的数字资产管理子系统 DAM，面向政府部门、企事业单位、摄影协会、摄影爱好者等推出视觉内容资源智能管理服务，用于解决海量视觉内容资源的在线管理、分享与展示等问题。`
        }
      ],
      opacity: "0.68"
    };
  },

  mounted() {
    // window.addEventListener("scroll", this.mosewheel, true);
  },
  methods: {
    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    }
  }
};
</script>
<style lang="less">
.valueservice {
  .el-main {
    padding: 0px !important;
    .maintop {
      height: 200px;
      background-color: teal;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
    }
    .mainbottom {
      padding: 0px 180px;
      margin: 20px 0px;
    }
  }
  .el-footer{
    padding: 0px;
  }
}
</style>









// WEBPACK FOOTER //
// src/page/valueaddservice.vue